import React from "react";

import cn from "classnames";

import { Select as AntSelect } from "antd";

import { Inscription } from "../../inscription";

import styles from "./styles.module.scss";

export interface SelectorValue {
  value: string;
  title: string | React.ReactNode;
  disabled?: boolean;
}

export interface SelectorProps {
  className?: string;

  title: string;
  placeholder?: string;

  disabled?: boolean;
  loading?: boolean;

  value?: string;
  options: SelectorValue[];
  onSelect?: (value?: string) => void;
}

export const Selector: React.FC<SelectorProps> = (props) => {
  const { title, placeholder, className, value, options, loading, onSelect, disabled } = props;

  const defaultValue = "default";
  const handleSelect = (selectedValue: string) => {
    onSelect && onSelect(selectedValue !== defaultValue ? selectedValue : undefined);
  };

  return (
    <Inscription title={title}>
      <AntSelect
        value={value}
        loading={loading}
        onSelect={handleSelect}
        placeholder={placeholder}
        disabled={disabled || loading}
        className={cn([styles.select, className])}
      >
        {options.map((option, idx) => (
          <AntSelect.Option key={`selector-option-${idx}`} value={option.value} disabled={option.disabled ?? false}>
            {option.title}
          </AntSelect.Option>
        ))}
      </AntSelect>
    </Inscription>
  );
};
